import React from 'react';

import VerticalBars from '../../../components/charts/chartjs/sonar-vertical-bars/SonarVerticalBars';
import { SONAR_DATA_KEYS } from '../../../utils/chart';

function InterestTrend({ domainEntries }) {
  //! TEMPORARY SOLUTION
  let tempDomainEntries = domainEntries;

  if (domainEntries.length && !domainEntries[0][SONAR_DATA_KEYS.INTEREST]) {
    tempDomainEntries = [];
  }

  return (
    <VerticalBars data={tempDomainEntries} dataKey={SONAR_DATA_KEYS.INTEREST} height='400px' customTooltip showTrend />
  );
}

export default InterestTrend;
